import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { EmployeeRepository }   from 'Domain/Repositories';
import { message }              from 'antd';

export const createEmployeeEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createEmployeeRequest.type),
    mergeMap(action => from(EmployeeRepository.create(action.payload.formData))
      .pipe(
        mergeMap((employee) => {
          message.success('Verwaltungsnutzer wurde erfolgreich erstellt');
          return from([
            Actions.createEmployeeSuccess({ employee })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createEmployeeFailure({ error }),
          ]);
        })
      )
    ),
  );
};
